import circularBars from "./circular-bars.html";
import "./circular-bars.css";

export default circularBars;
